import type { ButtonProps } from '@mui/material'
import { Button } from '@mui/material'
import type { FC } from 'react'

import { LinkUnstyled } from '@hcr/ui'

import { COLORS } from '../../../../../../libs/ui/src/lib/constants'
import { unit } from '../../../../../../libs/ui/src/lib/utils'
import { LINK_CONFIG } from '../../../configs'
import { useUserDetails } from '../../../contexts'
import { useLocale } from '../../../hooks'

import { ButtonBuyAccommodationSubmit } from './ButtonBuyAccommodationSubmit'
import { ButtonBuyAccommodationWrapper } from './ButtonBuyAccommodationWrapper'

interface ButtonBuyAccommodationCardProps extends Pick<ButtonProps, 'children' | 'color' | 'variant'> {
  isDrawerOpen?: boolean
  onClickOpenDrawer?: () => void
  resortId?: number
}

// TODO 21: Component: Book new holiday
//  https://hcrdevelopment.atlassian.net/browse/SII-21
//  - Add the resortId parameter back once it's clear what it is
export const ButtonBuyAccommodationCard: FC<ButtonBuyAccommodationCardProps> = ({
  color,
  variant,
  isDrawerOpen,
  onClickOpenDrawer,
}) => {
  const userDetails = useUserDetails()
  const locale = useLocale()

  if (userDetails.data?.has_active_contracts && !isDrawerOpen) {
    return (
      <ButtonBuyAccommodationWrapper>
        <Button onClick={onClickOpenDrawer} variant={variant} color={color}>
          <ButtonBuyAccommodationSubmit />
        </Button>
      </ButtonBuyAccommodationWrapper>
    )
  }

  return (
    <ButtonBuyAccommodationWrapper>
      <Button
        component={LinkUnstyled}
        // to={LINK_CONFIG.store[locale.id] + (isNotUndefined(resortId) ? encodeSearchParams({ resortId }) : '')}
        to={LINK_CONFIG.store[locale.id]}
        variant={variant}
        color={color}
        rel='external'
        sx={{ border: `${unit(0.25)} solid ${COLORS.white}`, flexDirection: 'row', gap: unit(1.5) }}
      >
        <ButtonBuyAccommodationSubmit />
      </Button>
    </ButtonBuyAccommodationWrapper>
  )
}
